(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gekha-related-products"]) return;
  try {
    
(function () {
  var section = document.querySelector('.gekha-related-products[data-url]');
  if (!section) return;

  var xhr = new XMLHttpRequest();
  xhr.open('GET', section.dataset.url);
  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {
      var tmp = document.createElement('div');
      tmp.innerHTML = xhr.responseText;
      var fresh = tmp.querySelector('.gekha-related-products');
      if (fresh) {
        section.innerHTML = fresh.innerHTML;
        // Distinct event name (not shopify:section:load) — the listener
        // below reuses that name to trigger a re-fetch, and dispatching it
        // here too would loop forever.
        document.dispatchEvent(new CustomEvent('gekha:related-products:loaded', {
          detail: { sectionId: section.dataset.sectionId }
        }));
      }
    }
  };
  xhr.send();

  document.addEventListener('shopify:section:load', function (e) {
    if (section && section.dataset.sectionId === String(e.detail.sectionId)) {
      xhr.open('GET', section.dataset.url);
      xhr.send();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gk2-featured-collection"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function initGk2Fc() {
        document.querySelectorAll('.gk2-fc__row-wrap:not([data-gk2-init])').forEach(function (wrap) {
          wrap.setAttribute('data-gk2-init', 'true');
          var swiperEl = wrap.querySelector('.gk2-fc__swiper');
          var prev = wrap.querySelector('[data-gk2-fc-prev]');
          var next = wrap.querySelector('[data-gk2-fc-next]');
          if (!swiperEl || typeof Swiper === 'undefined') return;
          new Swiper(swiperEl, {
            slidesPerView: 2,
            spaceBetween: 16,
            loop: true,
            watchOverflow: true,
            navigation: { nextEl: next, prevEl: prev },
            a11y: { enabled: true },
            keyboard: { enabled: true },
            breakpoints: {
              750: { slidesPerView: 4, spaceBetween: 24 }
            }
          });
        });
      }
      if (typeof Swiper === 'undefined') {
        window.addEventListener('load', initGk2Fc);
      } else {
        initGk2Fc();
      }
      document.addEventListener('shopify:section:load', initGk2Fc);
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gk2-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGk2Hero() {
      document.querySelectorAll('.gk2-hero__swiper:not([data-gk2-init])').forEach(function (el) {
        el.setAttribute('data-gk2-init', 'true');
        if (typeof Swiper === 'undefined') return;
        var autoplay = el.dataset.autoplay === 'true'
          ? { delay: parseInt(el.dataset.speed, 10) || 5000, disableOnInteraction: false, pauseOnMouseEnter: true }
          : false;
        new Swiper(el, {
          loop: el.querySelectorAll('.swiper-slide').length > 1,
          autoplay: autoplay,
          keyboard: { enabled: true },
          a11y: { enabled: true },
          pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
          navigation: {
            nextEl: el.parentElement.querySelector('.gk2-hero__arrow--next'),
            prevEl: el.parentElement.querySelector('.gk2-hero__arrow--prev')
          }
        });
      });
    }
    if (typeof Swiper === 'undefined') {
      window.addEventListener('load', initGk2Hero);
    } else {
      initGk2Hero();
    }
    document.addEventListener('shopify:section:load', initGk2Hero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gk2-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGk2Marquee() {
      document.querySelectorAll('.gk2-marquee:not([data-gk2-init])').forEach(function (el) {
        el.setAttribute('data-gk2-init', 'true');
        var track = el.querySelector('.gk2-marquee__track');
        var speed = parseFloat(el.dataset.speed) || 60;
        if (track) track.style.setProperty('--gk2-marquee-speed', speed + 's');
      });
    }
    initGk2Marquee();
    document.addEventListener('shopify:section:load', initGk2Marquee);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gk2-reviews"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function initGk2Reviews() {
        document.querySelectorAll('[data-gk2-reviews-row]:not([data-gk2-init])').forEach(function (row) {
          row.setAttribute('data-gk2-init', 'true');
          if (row.dataset.autoplay !== 'true') return;
          var speed = parseInt(row.dataset.speed, 10) || 4000;
          var timer;
          function tick() {
            var card = row.querySelector('.gk2-reviews__card');
            var step = card ? card.getBoundingClientRect().width + 16 : 300;
            var atEnd = Math.ceil(row.scrollLeft + row.clientWidth) >= row.scrollWidth;
            row.scrollBy({ left: atEnd ? -row.scrollWidth : step, behavior: 'smooth' });
          }
          function start() { timer = setInterval(tick, speed); }
          function stop() { clearInterval(timer); }
          start();
          row.addEventListener('mouseenter', stop);
          row.addEventListener('mouseleave', start);
          row.addEventListener('touchstart', stop, { passive: true });
        });
      }
      initGk2Reviews();
      document.addEventListener('shopify:section:load', initGk2Reviews);
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
